import type { IconProps } from "../../src/types";
import { splitProps } from "solid-js";

function renderSvg(kebab: string, props: IconProps) {
  const [local, rest] = splitProps(props, ["class", "size", "color", "strokeWidth"]);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={local.size ?? 24}
      height={local.size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      stroke={local.color ?? "currentColor"}
      stroke-width={local.strokeWidth ?? 2}
      stroke-linecap="round"
      stroke-linejoin="round"
      class={local.class ? `lucide lucide-${kebab} ${local.class}` : `lucide lucide-${kebab}`}
      aria-hidden={rest["aria-label"] || rest.title ? undefined : "true"}
      {...rest}
    >
      <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z" />
      <path d="M14 2v5a1 1 0 0 0 1 1h5" />
      <path d="M10 9H8" />
      <path d="M16 13H8" />
      <path d="M16 17H8" />
    </svg>
  );
}

export const FileText = (props: IconProps) => renderSvg("file-text", props);
export const FileTextIcon = FileText;
export default FileText;
